<template>
    <main id="process-types-new-or-edit" class="wrapper-content w-100">
      <LmComponentLoading v-if="isLoading" fixed />

      <h1 v-if="!isOnEditMode">{{ $t('process_types_generator')}}</h1>
      <h1 v-if="isOnEditMode">{{ $t('process_types_edit')}}</h1>
      <LmForm ref="lmFormRef" >
        <LmTextInput
          id="typeName"
          :disabled="formData.published"
          class="col-12 px-0"
          :v="$v.formData.typeName"
          v-model="formData.typeName"
          :label="$t('process_type_name')"
          :placeholder="$t('process_type_name_placeholder')"
        />
        <LmTextInput
          id="typeAlias"
          :disabled="formData.published"
          class="col-12 px-0"
          :v="$v.formData.typeAlias"
          v-model="formData.typeAlias"
          :label="$t('process_type_alias')"
          :placeholder="$t('process_type_alias_placeholder')"
        />
        <LmTextArea
          id="typeDescription"
          class="col-12 px-0"
          v-model="formData.typeDescription"
          :v="$v.formData.typeDescription"
          :label="$t('process_type_description')"
          :placeholder="$t('process_type_description_placeholder')"
        />
        <h3>Configuraciones</h3>
        <b-card no-body class="border">
          <b-tabs card>
            <b-tab title="General" active>
              <b-row class="p-4" cols-md="4">
                <LmRadio
                  v-model="formData.typeNumerator"
                  @input="onNumeratorChange"
                  name="numerator"
                  :label="$t('numerator_type')"
                  isVertical
                  :help="$t('numerator_type_help')"
                  :options="[
                    {text: $t('generic'), value: 'generic'},
                    {text: $t('specific'), value: 'specific'}
                  ]"
                />
                <div>
                  <LmRadio
                    v-model="formData.typeComments"
                    name="comments"
                    :label="$t('Permite comentarios')"
                    isVertical
                    :help="$t('comments_type_help')"
                    :options="[
                      {text: $t('Siempre'), value: 'always'},
                      {text: $t('Nunca'), value: 'never'},
                      {text: $t('Mientras no este finalizado'), value: 'in_progress'},
                    ]"
                  />
                  <LmCheckbox
                    v-if="formData.typeComments === 'in_progress'"
                    labelSingle="Ocultar comentarios al finalizar"
                    v-model="formData.typeHideCommentsOnFinished"
                    :disabled="!formData.isEditable"
                  />
                </div>
                <div>
                  <LmRadio
                    v-model="formData.tadAvailable"
                    name="tad"
                    :label="$t('tad_available')"
                    isVertical
                    :help="$t('tad_available_help')"
                    :options="[
                      {text: 'Si', value: true},
                      {text: 'No', value: false}
                    ]"
                  />
                  <a-button v-if="formData.tadUrl && formData.tadAvailable" type="link" :href="formData.tadUrl" target="_blank">
                    Ir al sitio
                  </a-button>
                </div>
              </b-row>
              <LmTreeSelect
                id="typePrefix"
                class="col-md-4 px-0"
                v-model="formData.typePrefix"
                :v="$v.formData.typePrefix"
                :options="prefixOptionsForNumerator"
                :label="$t('prefix')"
                :placeholder="$t('process_prefix')"
                :help="$t('process_prefix_help')"
              />
              <hr class="w-100"/>
              <b-row>
                <h3 class="col-12">Template de Contenido</h3>
                <p class="col-auto">Si no ingresa ninguna condición los templates van a estar visible para todos los usuarios.</p>
                <LmConditionalBuilder
                  class="col-auto"
                  :maxConditions="1"
                  noGroups
                  view="processtypes"
                  ref="contenttemplateConditionals"
                  v-model="formData.contenttemplateConditionals"
                />
              </b-row>
              <hr class="w-100"/>
              <!-- FormBuilderUi -->
              <div id="lm-form-builder-ui" class="wrapper-content w-100 px-0 mt-3">
                <div class="row position-relative">
                  <div class="col-12">
                    <h3>{{ !formData.isEditable ? 'Previsualización del formulario' : 'Formulario de ingreso de datos' }}</h3>
                    <b-row>
                      <div class="col-12">
                        <b-form-group :label="$t('view_modes')">
                        <b-form-radio-group buttons button-variant="primary" v-model="modes.selected">
                          <b-form-radio
                            name="viewMode"
                            value="edit"
                            @change="modes.editView = $event === 'edit'"
                          >
                            <font-awesome-icon class="mr-1" icon="wrench" />
                            {{ formData.isEditable ? $t('edit_mode') : $t('view_config') }}
                          </b-form-radio>
                          <b-form-radio
                            name="viewMode"
                            value="preview"
                            @change="modes.editView = $event === 'edit'"
                          >
                            <font-awesome-icon class="mr-1" icon="eye" />
                            {{ $t('preview_mode') }}
                          </b-form-radio>
                        </b-form-radio-group>
                      </b-form-group>
                      </div>
                    </b-row>
                    <b-row>
                      <LmSuperPowerSelectV2
                        v-if="formData.isEditable"
                        class="col-12 col-md-6"
                        :options="processTypesOptionsForDuplicate"
                        @input="loadFormElements"
                        :label="$t('import_form_components_from_another_process_type')"
                      />
                    </b-row>
                    <div class="row" v-if="componentsOptions.content.length">
                      <div class="col-12 col-md-6 px-0 formbuilder-component-section border-right border-top" v-show="modes.editView">
                      <LmSvgIcon
                        v-if="form.formElements.length === 0"
                        wrapperClass="d-flex mt-4 justify-content-center align-items-center flex-column"
                        width="18em"
                        icon="LmSettingsIcon"
                        text="Creá el formulario agregando los campos que desees"
                      />
                        <LmForm ref="lmFormBuilderRef" id="processFormElements">
                          <draggable
                            class="col-12"
                            v-model="form.formElements"
                            @start="drag=true"
                            @end="drag=false"
                            animation="150"
                            handle=".handle"
                            >
                            <div v-for="(formElement, index) in form.formElements" :key="formElement.id" class="mt-4">
                              <header
                                class="d-flex justify-content-between align-items-center bg-primary text-white px-3 handle shadow rounded-lg"
                                :class="{'bg-info': !shouldCreatePortal(form.formElements[index].componentName)}">
                                <font-awesome-icon v-if="formData.isEditable" class="mr-4" icon="arrows-alt" style="width:18px; height:18px;" />
                                <h4 v-b-toggle="`collapse-${index}`" class="flex-grow-1 text-center my-0 py-3 handle">{{title(form.formElements[index])}}</h4>
                                <div v-if="shouldCreatePortal(form.formElements[index].componentName)" class="circle d-flex justify-content-center align-items-center">{{index}}</div>
                                <div class="d-flex align-items-center">
                                  <font-awesome-icon v-b-toggle="`collapse-${index}`" class="collapse-formsection-up ml-4 clickable" icon="chevron-up" style="width:16px; height:16px;" />
                                  <font-awesome-icon v-b-toggle="`collapse-${index}`" class="collapse-formsection-down ml-4 clickable" icon="chevron-down" style="width:16px; height:16px;" />
                                  <font-awesome-icon v-if="formData.isEditable" class="ml-4 clickable" icon="trash" @click="removeFormElement(index)" style="width:16px; height:16px;" />
                                </div>
                              </header>
                              <b-collapse
                                accordion="my-accordion"
                                :id="`collapse-${index}`"
                                visible
                                class="p-4 border border-top-0 rounded-lg"
                                >
                                <LmSelect
                                  :id="'select-elements-' + index"
                                  v-model="form.formElements[index].componentName"
                                  :options="componentsOptions"
                                  :label="$t('select_elemet_type')"
                                  @input="selectorElementForm($event, index)"
                                />
                                <component
                                  :index="index"
                                  :is="whatComponentBuilderUse(form.formElements[index].componentName)"
                                  :id="form.formElements[index].formObjectToSendToServerProperty || form.formElements[index].id"
                                  :componentData="form.formElements[index]"
                                  :optionsChildOf="buildOptionsChildOf(form.formElements[index].formObjectToSendToServerProperty)"
                                  :leftValueToCompareOptions="leftValueToCompareOptions(form.formElements[index])"
                                  :visibilityDependOnConditions="form.formElements[index].visibilityDependOnConditions"
                                  :optionsSameAsValidation="{content: buildSameAsOptions(form.formElements)}"
                                  :validationsData="getValidation(form.formElements[index].formObjectToSendToServerProperty)"
                                  :options="lmSuperPowerSelectV2BuilderUiOptions"
                                  :isOnEditMode="isOnEditMode"
                                  @input="inputHandler($event, index)"
                                  @validations-changes="validationsChangesHandler"
                                  v-bind="$attrs"
                                />
                                <template v-if="extraPropsForPdf(formElement)">
                                  <hr class="w-100">
                                  <section class="row">
                                    <h4 class="col-12">Propiedades para la carátula</h4>
                                    <LmCheckbox
                                      :disabled="formElement.hasLabelOnPdf"
                                      class="col-12"
                                      labelSingle="Ocultar al generar la carátula"
                                      v-model="formElement.isHiddenOnPdf"
                                    />
                                    <LmCheckbox
                                      :disabled="formElement.isHiddenOnPdf"
                                      class="col-12"
                                      labelSingle="Incluir título del campo en la carátula"
                                      v-model="formElement.hasLabelOnPdf"
                                    />
                                  </section>
                                </template>
                              </b-collapse>
                            </div>
                          </draggable>
                          <div class="col-12">
                            <LmButton
                              v-if="formData.isEditable"
                              id="add-field-button"
                              class="mt-4"
                              type="button"
                              lmButtonRootWrapperClass="d-inline-block"
                              lmButtonWrapperClass="col"
                              @click.native="addFormElement(form.formElements.length)"
                              :value="$t('add_field')"
                            />
                          </div>
                        </LmForm>
                      </div>
                      <!-- Preview del formbuilder que se generará -->
                      <div class="col-12 pt-4 formbuilder-preview-section border-top" :class="{ 'col-md-6': modes.editView }">
                        <LmFormBuilder
                          class="px-0"
                          :getComponents="form"
                          :isOnPreviewMode="modes.editView"
                          @openEditFormElement="openEditFormElement"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-tab>
            <b-tab title="Acciones">
              <LmProcessActions
                class="p-4"
                v-model="formData.instanceActions"
              />
              <LmProcessActionsEdit
                class="p-4"
                v-model="formData.instanceActionsEdit"
                :disabled="formData.published"
              />
            </b-tab>
            <b-tab title="Iniciadores">
              <LmProcessStarters
                class="p-4"
                v-model="formData.instanceStarters"
                :published="!formData.isEditable"
              />
            </b-tab>
            <!-- <b-tab title="Avanzado">
              <b-row class="p-4" cols-md="4">
                <div>
                  <h4>Tomar Trámites de este tipo</h4>
                  <p>Indique a dónde deben pertenecer los usuarios que pueden tomar trámites de este tipo.</p>
                  <LmRadio
                    :disabled="!formData.isEditable"
                    v-model="formData.typeCanBeTaken"
                    name="numerator"
                    label="¿Quiénes pueden tomar el trámite?"
                    isVertical
                    :help="$t('numerator_type_help')"
                    :options="[
                      {text: 'Área del destinatario', value: 'destinationArea'},
                      {text: 'Subárea del destinatario', value: 'destinationSubarea'},
                      {text: 'Otra área', value: 'externalArea'}
                    ]"
                  />
                  <LmTreeSelect
                    v-if="formData.typeCanBeTaken === 'externalArea'"
                    v-model="formData.typeCanBeTakenDetail"
                    label="Seleccione las áreas"
                    pathToGetOptions="/customer/areas"
                    multiple
                  />
                </div>
              </b-row>
            </b-tab> -->
            <b-tab title="Avanzado">
              <b-row class="p-4">
                <b-col class="col-6">
                  <h4>Subsanar documentación</h4>
                  <p>Indique quienes pueden subsanar los documentos que se asociaron a un trámite por error.</p>
                  <p>Por defecto lo puede realizar el usuario que asoció el documento desde la BUDD.</p>
                  <LmTreeSelect
                    :v="$v.formData.typeCorrection"
                    v-model="formData.typeCorrection"
                    label="Rol"
                    pathToGetOptions="/customer/roles"
                    clearable
                    multiple
                  />
                  <LmCheckbox
                    :v="$v.formData.userWhoAssociatedCanCorrect"
                    class="col-12"
                    labelSingle="Usuario que asoció el documento"
                    v-model="formData.userWhoAssociatedCanCorrect"
                  />
                </b-col>
              </b-row>
              <hr>
              <b-row class="p-4">
                <b-col class="col-6">
                  <h4>Reabrir trámites</h4>
                  <p>Indique quienes pueden este tipo de trámite.</p>
                  <p>Por defecto nadie puede reabrir los trámites.</p>
                  <LmTreeSelect
                    :v="$v.formData.typeReOpen"
                    v-model="formData.typeReOpen"
                    label="Rol"
                    pathToGetOptions="/customer/roles"
                    clearable
                    multiple
                  />
                </b-col>
              </b-row>
              <hr>
              <b-row class="p-4">
                <b-col class="col-6">
                  <h4>Tabla de Datos BUDD</h4>
                  <p>Permite usar una tabla de datos específica para buscar los documentos BUDD</p>

                  <div class="mt-3 d-flex" style="gap: .75rem">
                    <lm-button-v2 variant="info" v-b-modal.documents-datatable-modal type="primary">
                      Cambiar
                    </lm-button-v2>
                    <lm-button-v2 v-if="formData.customDatatableForBUDD" variant="info" v-b-modal.documents-datatable-modal-preview>
                      Ver
                    </lm-button-v2>
                    <lm-button-v2 variant="info"
                    v-if="formData.customDatatableForBUDD"
                    @click="formData.customDatatableForBUDD=null"
                    type="primary">
                      Listado por defecto
                    </lm-button-v2>
                  </div>

                  <b-modal
                    id="documents-datatable-modal-preview"
                    size="xl"
                    scrollable
                    :hide-footer="true"
                  >
                    <LmDataTable
                      v-if="formData.customDatatableForBUDD"
                      ref="datatable-app-documents-preview"
                      :slug="formData.customDatatableForBUDD"
                      hideButtons
                    />
                  </b-modal>

                  <b-modal
                    id="documents-datatable-modal"
                    size="xl"
                    scrollable
                    hide-header
                    @ok="onConfirmCustomDatatableToUse"
                    :cancel-title="$t('cancel')"
                    :ok-title="$t('confirm')"
                  >
                    <LmDataTable
                      ref="datatable-app-documents"
                      slug="tabla-de-datos-para-documentos"
                      hideButtons
                    />
                  </b-modal>

                </b-col>
              </b-row>
            </b-tab>
            <b-tab title="Integraciones">
              <b-row class="p-4">
                <b-col class="col-6">
                <LmRadio
                  v-model="formData.integrationAvailable"
                  name="integration-available"
                  :titleAsH4="true"
                  :label="$t('integration_available')"
                  isVertical
                  :help="$t('integration_available_help')"
                  :options="[
                    {text: 'Si', value: true},
                    {text: 'No', value: false}
                  ]"
                />
                </b-col>
                <b-col v-if="formData.integrationAvailable" class="col-12">
                  <hr>
                  <b-row>
                    <b-col class="col-10">
                      <h4>Código de ejemplo</h4>
                    </b-col>
                    <b-col class="col-2">
                      <lm-button-v2 class="float-right" shape="circle" icon="reload" @click="reloadDocumentationSamples()"/>
                    </b-col>
                  </b-row>
                    <b-card no-body class="border">
                      <b-tabs card>
                        <b-tab title="NodeJS" active>
                          <b-row>
                            <b-col class="col-12 mt-2">
                              <p>
                                El siguiente es un ejemplo en <a href="https://nodejs.org/" target="_blank" rel="noopener noreferrer">NodeJS</a> basado en la libreria <a href="https://axios-http.com/docs/intro" target="_blank" rel="noopener noreferrer">Axios</a>.
                              </p>
                              <p>
                                Estas integraciones requiere una autenticacion <strong>Oauth2</strong>, la cual también se incluye en el ejemplo.
                              </p>
                              <LmCodeInput
                                v-model="apiIntegrationCodeSample"
                              />
                            </b-col>
                          </b-row>
                        </b-tab>
                      </b-tabs>
                    </b-card>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab v-if="formData.tadAvailable" title="Templates de Email">
              <b-card no-body class="border">
                <b-tabs card>
                  <b-tab title="Aviso de trámite creado desde TAD" active>
                    <b-row>
                      <b-col class="col-6">
                        <h4>Email template a utilizar</h4>
                        <LmTreeSelect
                          :options="mailertemplateOptions"
                          v-model="formData.mailerTemplates.processCreatedForTad"
                        />
                        <h4>Variables disponibles para usar en los templates de mail</h4>
                        <ol>
                          <li>
                            <b-row>
                              <b-col class="col-12">
                                <strong><code>nombre_completo</code></strong>: Nombre y Apellido del iniciador.
                              </b-col>
                              <b-col class="col-12 mt-1">
                                <LmTextInput
                                  id="nombre_completo"
                                  v-model="emailContextProcessCreatedForTad.nombre_completo"
                                  mode="labelOnLeft"
                                  label="Ejemplo"
                                />
                              </b-col>
                            </b-row>
                          </li>
                          <li>
                            <b-row>
                              <b-col class="col-12">
                                <strong><code>correo_electonico</code></strong>: Correo electrónico del iniciador.
                              </b-col>
                              <b-col class="col-12 mt-1">
                                <LmTextInput
                                  id="correo_electonico"
                                  v-model="emailContextProcessCreatedForTad.correo_electonico"
                                  mode="labelOnLeft"
                                  label="Ejemplo"
                                />
                              </b-col>
                            </b-row>
                          </li>
                          <li class="mb-2">
                            <b-row>
                              <b-col class="col-12">
                                <strong><code>alias_tramite</code></strong>: Alias del tipo de trámite
                              </b-col>
                              <b-col class="col-12 mt-1">
                                <LmTextInput
                                  id="alias_tramite"
                                  v-model="emailContextProcessCreatedForTad.alias_tramite"
                                  mode="labelOnLeft"
                                  label="Ejemplo"
                                />
                              </b-col>
                            </b-row>
                          </li>
                          <li class="mb-2">
                            <b-row>
                              <b-col class="col-12">
                                <strong><code>url_tramite</code></strong>: Url para acceder el resumen del trámite
                              </b-col>
                              <b-col class="col-12 mt-1">
                                <LmTextInput
                                  id="url_tramite"
                                  v-model="emailContextProcessCreatedForTad.url_tramite"
                                  mode="labelOnLeft"
                                  label="Ejemplo"
                                />
                              </b-col>
                            </b-row>
                          </li>
                        </ol>
                      </b-col>
                      <b-col class="col-6">
                        <h4>Visualización del Email</h4>
                        <b-card class="border">
                          <b-card-text>
                          <div class="h-100" v-html="renderizedEmailTemplateForProcessCreated"></div>
                          </b-card-text>
                        </b-card>
                      </b-col>
                    </b-row>
                  </b-tab>
                  <b-tab title="Aviso de trámite TAD iniciado">
                    <b-row>
                      <b-col class="col-6">
                        <h4>Email template a utilizar</h4>
                        <LmTreeSelect
                          :options="mailertemplateOptions"
                          v-model="formData.mailerTemplates.processStartedForTad"
                        />
                        <h4>Variables disponibles para usar en los templates de mail</h4>
                        <ol>
                          <li>
                            <b-row>
                              <b-col class="col-12">
                                <strong><code>nombre_completo</code></strong>: Nombre y Apellido del iniciador.
                              </b-col>
                              <b-col class="col-12 mt-1">
                                <LmTextInput
                                  id="nombre_completo"
                                  v-model="emailContextProcessStartedForTad.nombre_completo"
                                  mode="labelOnLeft"
                                  label="Ejemplo"
                                />
                              </b-col>
                            </b-row>
                          </li>
                          <li>
                            <b-row>
                              <b-col class="col-12">
                                <strong><code>correo_electonico</code></strong>: Correo electrónico del iniciador.
                              </b-col>
                              <b-col class="col-12 mt-1">
                                <LmTextInput
                                  id="correo_electonico"
                                  v-model="emailContextProcessStartedForTad.correo_electonico"
                                  mode="labelOnLeft"
                                  label="Ejemplo"
                                />
                              </b-col>
                            </b-row>
                          </li>
                          <li class="mb-2">
                            <b-row>
                              <b-col class="col-12">
                                <strong><code>alias_tramite</code></strong>: Alias del tipo de trámite
                              </b-col>
                              <b-col class="col-12 mt-1">
                                <LmTextInput
                                  id="alias_tramite"
                                  v-model="emailContextProcessStartedForTad.alias_tramite"
                                  mode="labelOnLeft"
                                  label="Ejemplo"
                                />
                              </b-col>
                            </b-row>
                          </li>
                          <li class="mb-2">
                            <b-row>
                              <b-col class="col-12">
                                <strong><code>url_tramite</code></strong>: Url para acceder el resumen del trámite
                              </b-col>
                              <b-col class="col-12 mt-1">
                                <LmTextInput
                                  id="url_tramite"
                                  v-model="emailContextProcessStartedForTad.url_tramite"
                                  mode="labelOnLeft"
                                  label="Ejemplo"
                                />
                              </b-col>
                            </b-row>
                          </li>
                          <li class="mb-2">
                            <b-row>
                              <b-col class="col-12">
                                <strong><code>numero_tramite</code></strong>: Número del trámite
                              </b-col>
                              <b-col class="col-12 mt-1">
                                <LmTextInput
                                  id="numero_tramite"
                                  v-model="emailContextProcessStartedForTad.numero_tramite"
                                  mode="labelOnLeft"
                                  label="Ejemplo"
                                />
                              </b-col>
                            </b-row>
                          </li>
                        </ol>
                      </b-col>
                      <b-col class="col-6">
                        <h4>Visualización del Email</h4>
                        <b-card class="border">
                          <b-card-text>
                          <div class="h-100" v-html="renderizedEmailTemplateForProcessStarted"></div>
                          </b-card-text>
                        </b-card>
                      </b-col>
                    </b-row>
                  </b-tab>
                  <b-tab title="Aviso de trámite TAD rechazado">
                    <b-row>
                      <b-col class="col-6">
                        <h4>Email template a utilizar</h4>
                        <LmTreeSelect
                          :options="mailertemplateOptions"
                          v-model="formData.mailerTemplates.processRejectedForTad"
                        />
                        <h4>Variables disponibles para usar en los templates de mail</h4>
                        <ol>
                          <li>
                            <b-row>
                              <b-col class="col-12">
                                <strong><code>nombre_completo</code></strong>: Nombre y Apellido del iniciador.
                              </b-col>
                              <b-col class="col-12 mt-1">
                                <LmTextInput
                                  id="nombre_completo"
                                  v-model="emailContextProcessRejectedForTad.nombre_completo"
                                  mode="labelOnLeft"
                                  label="Ejemplo"
                                />
                              </b-col>
                            </b-row>
                          </li>
                          <li>
                            <b-row>
                              <b-col class="col-12">
                                <strong><code>correo_electonico</code></strong>: Correo electrónico del iniciador.
                              </b-col>
                              <b-col class="col-12 mt-1">
                                <LmTextInput
                                  id="correo_electonico"
                                  v-model="emailContextProcessRejectedForTad.correo_electonico"
                                  mode="labelOnLeft"
                                  label="Ejemplo"
                                />
                              </b-col>
                            </b-row>
                          </li>
                          <li class="mb-2">
                            <b-row>
                              <b-col class="col-12">
                                <strong><code>alias_tramite</code></strong>: Alias del tipo de trámite
                              </b-col>
                              <b-col class="col-12 mt-1">
                                <LmTextInput
                                  id="alias_tramite"
                                  v-model="emailContextProcessRejectedForTad.alias_tramite"
                                  mode="labelOnLeft"
                                  label="Ejemplo"
                                />
                              </b-col>
                            </b-row>
                          </li>
                          <li class="mb-2">
                            <b-row>
                              <b-col class="col-12">
                                <strong><code>url_tramite</code></strong>: Url para acceder el resumen del trámite
                              </b-col>
                              <b-col class="col-12 mt-1">
                                <LmTextInput
                                  id="url_tramite"
                                  v-model="emailContextProcessRejectedForTad.url_tramite"
                                  mode="labelOnLeft"
                                  label="Ejemplo"
                                />
                              </b-col>
                            </b-row>
                          </li>
                          <li class="mb-2">
                            <b-row>
                              <b-col class="col-12">
                                <strong><code>motivo_rechazo</code></strong>: Motivo por el que se rechazó el trámite
                              </b-col>
                              <b-col class="col-12 mt-1">
                                <LmTextArea
                                  id="motivo_rechazo"
                                  v-model="emailContextProcessRejectedForTad.motivo_rechazo"
                                  mode="labelOnLeft"
                                  label="Ejemplo"
                                />
                              </b-col>
                            </b-row>
                          </li>
                        </ol>
                      </b-col>
                      <b-col class="col-6">
                        <h4>Visualización del Email</h4>
                        <b-card class="border">
                          <b-card-text>
                          <div class="h-100" v-html="renderizedEmailTemplateForProcessRejected"></div>
                          </b-card-text>
                        </b-card>
                      </b-col>
                    </b-row>
                  </b-tab>
                </b-tabs>
              </b-card>
            </b-tab>
            <b-tab title="Planos">
              <LmRadio
                v-model="formData.typeAllowBlueprints"
                name="blueprints"
                :titleAsH4="true"
                isVertical
                :label="$t('allow_blueprints')"
                :help="$t('allow_blueprints_type_help')"
                :options="[
                  {text: $t('allow'), value: true},
                  {text: $t('not_allow'), value: false}
                ]"
              />
              <hr v-if="formData.typeAllowBlueprints" class="w-100"/>

              <LmBlueprintTypesPrivileges
                v-if="formData.typeAllowBlueprints"
                title="Quienes pueden eliminar Planos"
                description="<p>Seleccione que usuarios pueden eliminar planos que fueron asociados a este tipo de trámite tipo. Puede seleccionar /los que pertenezcan a un Área o Subárea, o los usuarios con determinado Perfil.</p><p>Si no selecciona nada, todos los usuarios van a poder eliminar planos de este tipo de trámite.</p>"
                v-model="formData.blueprintsCanBeDeletedBy"
              />

              <div v-if="formData.typeAllowBlueprints">
                <hr class="w-100"/>
                <h4>Tabla de datos para buscar planos</h4>
                <p>Permite usar una tabla de datos específica para asociar planos a los trámites</p>

                <div class="mt-3 d-flex" style="gap: .75rem">
                  <lm-button-v2 variant="info" v-b-modal.blueprints-datatable-modal type="primary">
                    Cambiar
                  </lm-button-v2>
                  <lm-button-v2 v-if="formData.customDatatableForBlueprints" variant="info" v-b-modal.blueprints-datatable-modal-preview>
                    Ver
                  </lm-button-v2>
                  <lm-button-v2 variant="info"
                  v-if="formData.customDatatableForBlueprints"
                  @click="formData.customDatatableForBlueprints=null"
                  type="primary">
                    Listado por defecto
                  </lm-button-v2>
                </div>

                <b-modal
                  id="blueprints-datatable-modal-preview"
                  size="xl"
                  scrollable
                  :hide-footer="true"
                >
                  <LmDataTable
                    v-if="formData.customDatatableForBlueprints"
                    ref="datatable-app-blueprints-preview"
                    :slug="formData.customDatatableForBlueprints"
                    hideButtons
                  />
                </b-modal>

                <b-modal
                  id="blueprints-datatable-modal"
                  size="xl"
                  scrollable
                  hide-header
                  @ok="onConfirmCustomBlueprintsDatatableToUse"
                  :cancel-title="$t('cancel')"
                  :ok-title="$t('confirm')"
                >
                  <LmDataTable
                    ref="datatable-app-blueprints"
                    slug="tabla-de-datos-para-planos"
                    hideButtons
                  />
                </b-modal>
              </div>
            </b-tab>
          </b-tabs>
        </b-card>
      </LmForm>
      <!-- Action Buttons -->
      <hr class="w-100">
      <div class="d-flex wrapper-content pl-0">
        <LmButton
          class="col-auto pl-0"
          type="cancel"
          :value="$t('cancel')"
          buttonClass="btn-secondary"
          @click="onCancel()"
        />
        <LmButton
          v-if="!formData.published && formData.isEditable"
          class="col-auto"
          type="button"
          :value="$t('save')"
          buttonClass="btn-primary"
          @click="onSubmit()"
        />
        <LmButton
          v-if="isOnEditMode && !formData.published"
          class="col-auto"
          type="button"
          :value="formData.isEditable? $t('save_and_publish') : $t('publish')"
          buttonClass="btn-info"
          :requireConfirmation="true"
          :confirmationTitle="$t('process_publish_confirmation_title')"
          :confirmationMessage="$t('process_publish_confirmation_message')"
          @click="onPublish()"
        />
        <LmButton
          v-if="isOnEditMode && formData.published"
          class="col-auto"
          type="button"
          value="Despublicar"
          buttonClass="btn-warning"
          :requireConfirmation="true"
          :confirmationTitle="$t('process_defuse_confirmation_title')"
          :confirmationMessage="$t('process_defuse_confirmation_message')"
          @click="onUnpublish()"
        />
        <LmButton
        v-if="isOnEditMode"
        class="col-auto"
        type="button"
        value="Duplicar"
        buttonClass="btn-info"
        requireConfirmation
        confirmationTitle="¿Estas seguro?"
        confirmationMessage="Vas a duplicar el tipo de trámite completamente."
        @click="onClone()"
      />
      <LmButton
        v-if="isOnEditMode && formData.published"
        class="col-auto"
        type="button"
        value="Actualizar"
        buttonClass="btn-success"
        requireConfirmation
        confirmationTitle="¿Estas seguro?"
        confirmationMessage="El proceso de Actualizacion crea un nuevo tipo de trámite y despublica el anterior."
        @click="onEdit()"
      />
      <LmButton
        v-if="isOnEditMode"
        class="col-auto"
        type="button"
        :value="$t('delete')"
        buttonClass="btn-danger"
        action="delete"
        @click="onDelete()"
      />
      </div>
      <b-modal
        id="create-starter-modal"
        title="No hay tipos de personas o iniciadores creados"
        hide-footer
        centered
        size="xl"
        no-close-on-backdrop
        no-close-on-esc
        @hidden="$router.go(-1)"
      >
        <b-row cols="2">
          <b-col>
            <b-card
              border-variant="primary"
              header="Tipo de persona"
              header-bg-variant="primary"
              header-text-variant="white"
              class="border clickable"
              align="center"
              @click="$router.push('/tiposdepersonas/nuevo')"
            >
              <b-card-text>Crear tipo de persona</b-card-text>
            </b-card>
          </b-col>
          <b-col>
            <b-card
              border-variant="primary"
              header="Tipo de iniciador"
              header-bg-variant="primary"
              header-text-variant="white"
              class="border clickable"
              align="center"
              @click="$router.push('/tiposdeiniciadores/nuevo')"
            >
              <b-card-text>Crear tipo de iniciador</b-card-text>
            </b-card>
          </b-col>
        </b-row>
      </b-modal>
    </main>
</template>

<script>
// Components
import LmButton from '@/components/form/elements/LmButton'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmTextArea from '@/components/form/elements/LmTextArea'
import LmEmailInput from '@/components/form/elements/LmEmailInput'
import LmRadio from '@/components/form/elements/LmRadio'
import LmCheckbox from '@/components/form/elements/LmCheckbox'
import LmSelect from '@/components/form/elements/LmSelect'
import LmForm from '@/components/form/LmForm'
import LmTreeSelect from '@/components/form/elements/LmTreeSelect'
import LmProcessPrivileges from '@/components/LmProcessPrivileges'
import LmProcessStarters from '@/components/LmProcessStarters'
import LmCaratulatorsPrivileges from '@/components/LmCaratulatorsPrivileges'
import LmSuperPowerSelectV2 from '@/components/form/elements/LmSuperPowerSelectV2'
import LmButtonV2 from '@/components/form/elements/LmButtonV2'
import LmDataTable from '@/components/lmDataTable/table'

// Form Builder
import LmTextNumberEditorTextAreaPasswordBuilderUi from '@/components/lmFormBuilderUi/LmTextNumberEditorTextAreaPasswordBuilderUi'
import LmEmailInputBuilderUi from '@/components/lmFormBuilderUi/LmEmailInputBuilderUi'
import LmFormSubtitlesBuilderUi from '@/components/lmFormBuilderUi/LmFormSubtitlesBuilderUi'
import LmFormEmptySpaceBuilderUi from '@/components/lmFormBuilderUi/LmFormEmptySpaceBuilderUi'
import LmFormSeparatorBuilderUi from '@/components/lmFormBuilderUi/LmFormSeparatorBuilderUi'
import LmSelectBuilderUi from '@/components/lmFormBuilderUi/LmSelectBuilderUi'
import LmSuperPowerSelectV2BuilderUi from '@/components/lmFormBuilderUi/LmSuperPowerSelectV2BuilderUi'
import LmButtonBuilderUi from '@/components/lmFormBuilderUi/LmButtonBuilderUi'
import LmDateBuilderUi from '@/components/lmFormBuilderUi/LmDateBuilderUi'
import LmDateTimeBuilderUi from '@/components/lmFormBuilderUi/LmDateTimeBuilderUi'
import LmLeaFletMapBuilderUi from '@/components/lmFormBuilderUi/LmLeaFletMapBuilderUi'
import LmHtmlContentBuilderUi from '@/components/lmFormBuilderUi/LmHtmlContentBuilderUi'
import LmFormPortalBuilderUi from '@/components/lmFormBuilderUi/LmFormPortalBuilderUi'
import LmColorPickerBuilderUi from '@/components/lmFormBuilderUi/LmColorPickerBuilderUi'
import LmCommentBuilderUi from '@/components/lmFormBuilderUi/LmCommentBuilderUi'
import LmRepeatFieldsBuilderUi from '@/components/lmFormBuilderUi/LmRepeatFieldsBuilderUi'
import LmCheckboxBuilderUi from '@/components/lmFormBuilderUi/LmCheckboxBuilderUi'
import LmUploadFilesBuilderUi from '@/components/lmFormBuilderUi/LmUploadFilesBuilderUi'
import LmSignersBuilderUi from '@/components/lmFormBuilderUi/LmSignersBuilderUi'
import LmImportFromExcelBuilderUi from '@/components/lmFormBuilderUi/LmImportFromExcelBuilderUi'
import LmCustomBuilderUi from '@/components/lmFormBuilderUi/LmCustomBuilderUi'
import LmRadioBuilderUi from '@/components/lmFormBuilderUi/LmRadioBuilderUi'
import LmCodeInputBuilderUi from '@/components/lmFormBuilderUi/LmCodeInputBuilderUi'
import LmCodeInput from '@/components/form/elements/LmCodeInput'
import LmTreeSelectBuilderUi from '@/components/lmFormBuilderUi/LmTreeSelectBuilderUi'
import LmEditorBuilderUi from '@/components/lmFormBuilderUi/LmEditorBuilderUi'
import LmReaderInputBuilderUi from '@/components/lmFormBuilderUi/LmReaderInputBuilderUi'
import LmTagsInputBuilderUi from '@/components/lmFormBuilderUi/LmTagsInputBuilderUi'
import draggable from 'vuedraggable'
import LmFormBuilder from '@/components/LmFormBuilder'
import LmConditionalBuilder from '@/components/lmConditionalBuilder'
import LmProcessActions from '@/components/LmProcessActions'
import LmProcessActionsEdit from '@/components/LmProcessActionsEdit'
import LmPageBreakBuilderUi from '@/components/lmFormBuilderUi/LmPageBreakBuilderUi'
import LmDatePickerBuilderUi from '@/components/lmFormBuilderUi/LmDatePickerBuilderUi'
import LmBlueprintTypesPrivileges from '@/components/LmBlueprintTypesPrivileges'

// Utils
import commonsApi from '@/api/commons'
import lmToasts from '@/mixins/lmToasts.js'
import lmFormBuilderUi from '@/mixins/lmFormBuilderUi.js'
import { required, maxLength } from 'vuelidate/lib/validators'

export default {
  mixins: [lmToasts, lmFormBuilderUi],
  provide () {
    const context = {}
    for (const key in this.form) {
      Object.defineProperty(context, key, {
        enumerable: true,
        get: () => this.form[key]
      })
    }
    return { context }
  },
  components: {
    LmConditionalBuilder,
    LmProcessActions,
    LmProcessActionsEdit,
    LmForm,
    LmButton,
    LmTextInput,
    LmTextArea,
    LmEmailInput,
    LmTreeSelect,
    LmRadio,
    LmCheckbox,
    LmSelect,
    LmProcessPrivileges,
    LmProcessStarters,
    LmCaratulatorsPrivileges,
    LmSuperPowerSelectV2,
    LmTextNumberEditorTextAreaPasswordBuilderUi,
    LmEmailInputBuilderUi,
    LmFormSubtitlesBuilderUi,
    LmFormEmptySpaceBuilderUi,
    LmFormSeparatorBuilderUi,
    LmSelectBuilderUi,
    LmSuperPowerSelectV2BuilderUi,
    LmButtonBuilderUi,
    LmDateBuilderUi,
    LmDateTimeBuilderUi,
    LmLeaFletMapBuilderUi,
    LmHtmlContentBuilderUi,
    LmFormPortalBuilderUi,
    LmColorPickerBuilderUi,
    LmCommentBuilderUi,
    LmRepeatFieldsBuilderUi,
    LmCheckboxBuilderUi,
    LmUploadFilesBuilderUi,
    LmSignersBuilderUi,
    LmImportFromExcelBuilderUi,
    LmCustomBuilderUi,
    LmRadioBuilderUi,
    LmCodeInputBuilderUi,
    LmCodeInput,
    LmTreeSelectBuilderUi,
    LmEditorBuilderUi,
    LmReaderInputBuilderUi,
    LmTagsInputBuilderUi,
    draggable,
    LmFormBuilder,
    LmButtonV2,
    LmDataTable,
    LmPageBreakBuilderUi,
    LmDatePickerBuilderUi,
    LmBlueprintTypesPrivileges
  },
  props: {
    pathToRedirectOnCancel: {
      type: String,
      default: ''
    }
  },
  watch: {
    'formData.mailerTemplates.processCreatedForTad': {
      deep: true,
      handler (val) {
        this.renderEmailTemplatePreview(this.formData.mailerTemplates.processCreatedForTad.id, this.emailContextProcessCreatedForTad, 'renderizedEmailTemplateForProcessCreated')
      }
    },
    'emailContextProcessCreatedForTad': {
      deep: true,
      handler (val) {
        this.renderEmailTemplatePreview(this.formData.mailerTemplates.processCreatedForTad.id, this.emailContextProcessCreatedForTad, 'renderizedEmailTemplateForProcessCreated')
      }
    },
    'formData.mailerTemplates.processStartedForTad': {
      deep: true,
      handler (val) {
        this.renderEmailTemplatePreview(this.formData.mailerTemplates.processStartedForTad.id, this.emailContextProcessStartedForTad, 'renderizedEmailTemplateForProcessStarted')
      }
    },
    'emailContextProcessStartedForTad': {
      deep: true,
      handler (val) {
        this.renderEmailTemplatePreview(this.formData.mailerTemplates.processStartedForTad.id, this.emailContextProcessStartedForTad, 'renderizedEmailTemplateForProcessStarted')
      }
    },
    'formData.mailerTemplates.processRejectedForTad': {
      deep: true,
      handler (val) {
        const clonedEmailContextFormProcessReject = Object.assign({}, this.emailContextProcessRejectedForTad)

        clonedEmailContextFormProcessReject.motivo_rechazo = clonedEmailContextFormProcessReject.motivo_rechazo.replace(/(\r\n|\n|\r)/gm, '<br>')
        this.renderEmailTemplatePreview(this.formData.mailerTemplates.processRejectedForTad.id, clonedEmailContextFormProcessReject, 'renderizedEmailTemplateForProcessRejected')
      }
    },
    'emailContextProcessRejectedForTad': {
      deep: true,
      handler (val) {
        const clonedEmailContextFormProcessReject = Object.assign({}, this.emailContextProcessRejectedForTad)

        clonedEmailContextFormProcessReject.motivo_rechazo = clonedEmailContextFormProcessReject.motivo_rechazo.replace(/(\r\n|\n|\r)/gm, '<br>')
        this.renderEmailTemplatePreview(this.formData.mailerTemplates.processRejectedForTad.id, clonedEmailContextFormProcessReject, 'renderizedEmailTemplateForProcessRejected')
      }
    }
  },
  data () {
    return {
      deleted: false,
      apiIntegrationCodeSample: '',
      emailContextProcessCreatedForTad: {
        nombre_completo: 'Angel Perez',
        correo_electonico: 'angel@test.com.ar',
        alias_tramite: 'Arbolado',
        url_tramite: 'https://url-de-ejemplo.com.ar'
      },
      emailContextProcessStartedForTad: {
        nombre_completo: 'Angel Perez',
        correo_electonico: 'angel@test.com.ar',
        alias_tramite: 'Arbolado',
        url_tramite: 'https://url-de-ejemplo.com.ar',
        numero_tramite: 'TRAM-100-2023'
      },
      emailContextProcessRejectedForTad: {
        nombre_completo: 'Angel Perez',
        correo_electonico: 'angel@test.com.ar',
        alias_tramite: 'Arbolado',
        url_tramite: 'https://url-de-ejemplo.com.ar',
        motivo_rechazo: 'Razon por la que se rechazó'
      },
      renderizedEmailTemplateForProcessCreated: '',
      renderizedEmailTemplateForProcessStarted: '',
      renderizedEmailTemplateForProcessRejected: '',
      formData: {
        typeName: '',
        typeAlias: '',
        typeDescription: '',
        typeNumerator: 'generic',
        typeComments: 'always',
        typeHideCommentsOnFinished: false,
        typeCanBeTaken: 'destinationArea',
        typeCanBeTakenDetail: null,
        published: false,
        typeClasification: 'internal',
        isEditable: true,
        typePrefix: '',
        typeAllowBlueprints: false,
        blueprintsCanBeDeletedBy: {
          area: [],
          subarea: [],
          profilegroups: []
        },
        tadAvailable: false,
        integrationAvailable: false,
        tadUrl: '',
        instanceStarters: {
          peopleTypes: [],
          initiatorTypes: []
        },
        typeCorrection: null,
        typeReOpen: null,
        userWhoAssociatedCanCorrect: false,
        instanceActions: {
          area: [],
          subarea: []
        },
        instanceActionsEdit: {
          area: [],
          subarea: [],
          role: []
        },
        contenttemplateConditionals: null,
        customDatatableForBUDD: null,
        customDatatableForBlueprints: null,
        mailerTemplates: {
          processCreatedForTad: null,
          processStartedForTad: null,
          processRejectedForTad: null
        }
      },
      form: {
        validations: {},
        formElements: [],
        lumbreInternal: true
      },
      isLoading: false,
      prefixOptions: null,
      modes: {
        selected: 'edit',
        editView: true
      },
      processTypesOptionsForDuplicate: [],
      componentsOptions: {
        content: []
      },
      mailertemplateOptions: []
    }
  },
  validations: {
    formData: {
      typeName: {
        required
      },
      typeAlias: {
        required
      },
      typeDescription: {
        required
      },
      tadAvailable: {
        required
      },
      typePrefix: {
        required,
        name: {
          maxLength: maxLength(5)
        }
      },
      typeCorrection: {},
      typeReOpen: {},
      userWhoAssociatedCanCorrect: {}
    }
  },
  computed: {
    prefixOptionsForNumerator () {
      if (this.prefixOptions) {
        return this.prefixOptions.filter(el => el.numeratorType === this.formData.typeNumerator)
      }
      return null
    },
    mailerTemplatePath () {
      return '/mailertemplate/all?type=email&format=minimal'
    }
  },
  methods: {
    async onNumeratorChange (event) {
      try {
        const prefixOptions = await commonsApi.axiosGetWrapper(`/customer/processprefixes/${event}`)
        this.prefixOptions = prefixOptions.data.items.map(el => {
          return {
            id: el.id,
            name: el.prefix,
            numeratorType: el.numeratorType
          }
        })
        if (!this.prefixOptions.some(el => el.id === this.formData.typePrefix.id)) {
          this.formData.typePrefix = null
        }
      } catch (error) {
        this.lmToastDangerMessage(error?.response?.data?.message, 'Error')
      }
    },
    async loadFormElements (event) {
      try {
        if (Array.isArray(event) && !event.length) {
          this.form.formElements = []
        } else {
          const processtype = await commonsApi.axiosGetWrapper(`processtypes/${event.id}`)
          const fields = processtype.data.processFields
          this.form.formElements = fields
        }
      } catch (error) {
        console.log(error)
      }
    },
    title (component) {
      if (this.componentsOptions?.content?.length) {
        const componentLabel = component?.componentProps?.label
        const componentValue = component?.componentProps?.value
        const componentText = component?.componentProps?.text
        const { text } = this.componentsOptions.content.find(e => e.value === component?.componentName)
        let moreInfo = ''
        if (componentLabel) {
          moreInfo += ' - ' + componentLabel
        } else if (componentValue) {
          moreInfo += ' - ' + componentValue
        } else if (componentText) {
          moreInfo += ' - ' + componentText
        }
        return text + moreInfo
      } else {
        return ''
      }
    },
    shouldCreatePortal (componentName) {
      return componentName !== 'LmComment'
    },
    extraPropsForPdf (element) {
      const excludedElements = [
        'LmFormSeparator',
        'LmFormEmptySpace',
        'LmFormSubtitles',
        'LmImportFromExcel'
      ]
      return !excludedElements.includes(element.componentName)
    },
    openEditFormElement (index) {
      this.$root.$emit('bv::toggle::collapse', `collapse-${index}`)
    },
    addFormElement (elementIndex) {
      this.selectorElementForm('LmTextInput', elementIndex)
    },
    leftValueToCompareOptions (formElementToExclude) {
      return {
        disabledOption: this.$t('Element'),
        content: this.form.formElements.filter(e => e.hasOwnProperty('formObjectToSendToServerProperty')).filter(e => e.id !== formElementToExclude.id).map(e => ({ value: e.formObjectToSendToServerProperty, text: e.componentProps.label }))
      }
    },
    validationsChangesHandler (payload) {
      let newValidation = {}
      const formValidationHasItem = Object.keys(this.form.validations).length
      if (formValidationHasItem) {
        for (const validation in this.form.validations) {
          const existFormObjectToSendToServerPropertyForValidation = this.form.formElements.find((el) => el.formObjectToSendToServerProperty === validation)
          if (existFormObjectToSendToServerPropertyForValidation) {
            newValidation = { ...newValidation, [validation]: this.form.validations[validation] }
          }
        }
        this.form.validations = { ...newValidation, ...payload }
      } else {
        this.form.validations = { ...this.form.validations, ...payload }
      }
    },
    validateInstanceActions () {
      return new Promise((resolve, reject) => {
        let valid = false
        if (
          !this.formData.instanceActions.area.length &&
          !this.formData.instanceActions.subarea.length
        ) {
          valid = true
        } else {
          for (const key in this.formData.instanceActions) {
            if (this.formData.instanceActions[key].some(el => el.action === 'S')) {
              valid = true
              break
            }
          }
        }
        if (!valid) {
          reject(new Error('Debe seleccional al menos un iniciador.'))
          this.lmToastDangerMessage('Debe seleccional al menos un iniciador.', 'Error')
        }
        resolve(valid)
      })
    },
    validateInstanceActionsEdit () {
      // Si va a editar trámites puede que seleccionen una subárea o un rol
      // si no seleccionan nada por defecto el editor es el administrador
      // de esta manera nos aseguramos la compatibilidad con los tipos trámites ya creados
      return new Promise((resolve, reject) => {
        let valid = false
        if (
          (!this.formData.instanceActionsEdit.area.length &&
          !this.formData.instanceActionsEdit.subarea.length) ||
          !this.formData.instanceActionsEdit.role.length
        ) {
          valid = true
        } else {
          valid = true // es el administrador
        }
        resolve(valid)
      })
    },
    inputHandler (event, index) {
      this.form.formElements[index] = event
    },
    async onSubmit () {
      try {
        this.isLoading = true
        // Validaciones
        await this.validateForm(this.$v)
        await this.validateInstanceActions()

        const processtypeData = {
          ...this.formData,
          processFields: [...this.form.formElements],
          processFieldsValidations: this.form.validations,
          contenttemplateConditionals: this.$refs.contenttemplateConditionals.conditionals
        }

        if (!this.isOnEditMode) {
          // Nuevo
          await commonsApi.axiosPostWrapper('/processtypes/', processtypeData)
          this.lmToastSuccessMessage(`Se creó el tipo de trámite correctamente.`, 'Se guardó exitosamente')
        } else {
          // Editar
          await commonsApi.axiosPutWrapper(`/processtypes/${this.$route?.params?.id}`, processtypeData)
          this.lmToastSuccessMessage(`Se editó el tipo de trámite correctamente.`, 'Se guardó exitosamente')
        }

        setTimeout(() => {
          this.$router.push(this.pathToRedirectOnCancel)
        }, 650)
      } catch (error) {
        if (error?.response?.data?.message) {
          this.lmModalDangerMessage({
            btnText: this.$t('try_again'),
            resultSubtitle: this.$t('talk_to_admin'),
            message: error?.response?.data?.message
          })
        } else {
          this.lmToastDangerMessage(error.message, 'Error de validación')
        }
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    onCancel () {
      this.$router.push(this.pathToRedirectOnCancel)
    },
    validateForm (validations) {
      return new Promise((resolve, reject) => {
        let error = false
        if (!validations.formData.typeCorrection.$model && !validations.formData.userWhoAssociatedCanCorrect.$model) {
          reject(new Error('Debe seleccionar un usuario o rol que pueda subsanar documentos.'))
        }
        if (!validations.formData.typeReOpen.$model) {
          reject(new Error('Debe seleccionar un rol que pueda reabrir este tipo de trámite.'))
        }
        validations.$touch()
        error = validations.$error
        if (error) {
          for (const key in this.formData) {
            if (validations.formData.hasOwnProperty(key)) {
              if (validations.formData[key].$error) {
                const selector = this.$el.querySelector(`#${key}`)
                selector.scrollIntoView({ behavior: 'smooth' })
                break
              }
            }
          }
          reject(new Error(this.$t('form_with_errors')))
        } else {
          resolve(true)
        }
      })
    },
    async onDelete () {
      try {
        this.isLoading = true

        await commonsApi.axiosPutWrapper(`/processtypes/delete/${this.$route?.params?.id}`)
        this.lmToastSuccessMessage(`Se eliminó el tipo de proceso correctamente.`, 'Se eliminó correctamente')

        setTimeout(() => {
          this.$router.push(this.pathToRedirectOnCancel)
        }, 650)
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    async onClone () {
      try {
        this.isLoading = true
        const r = await commonsApi.axiosPostWrapper(`/processtypes/clone-entity`, { id: this.$route.params.id })
        this.lmToastSuccessMessage(`Se duplicó ${r?.data?.typeName || ' el tipo de trámite'} correctamente.`, 'Se guardó exitosamente')
        setTimeout(() => {
          this.isLoading = false
          this.$router.push(this.pathToRedirectOnCancel)
        }, 650)
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    async onEdit () {
      try {
        this.isLoading = true
        // Validaciones
        await this.validateForm(this.$v)
        await this.validateInstanceActions()

        const processtypeData = {
          id: this.$route.params.id,
          ...this.formData,
          processFields: [...this.form.formElements],
          processFieldsValidations: this.form.validations,
          contenttemplateConditionals: this.$refs.contenttemplateConditionals.conditionals
        }

        const r = await commonsApi.axiosPostWrapper(`/processtypes/edit-entity`, processtypeData)
        this.lmToastSuccessMessage(`Se editó ${r?.data?.typeName || ' el tipo de trámite'} correctamente.`, 'Se guardó exitosamente')
        setTimeout(() => {
          this.isLoading = false
          this.$router.push(this.pathToRedirectOnCancel)
        }, 650)
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    async onPublish () {
      try {
        this.isLoading = true
        const processtypeData = {
          ...this.formData,
          processFields: [...this.form.formElements],
          processFieldsValidations: this.form.validations
        }

        await commonsApi.axiosPutWrapper(`/processtypes/publish/${this.$route?.params?.id}`, processtypeData)
        this.lmToastSuccessMessage(`Se publicó el tipo de proceso correctamente.`, 'Se publicó correctamente')

        setTimeout(() => {
          this.$router.push(this.pathToRedirectOnCancel)
        }, 650)
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    async onConfirmCustomDatatableToUse () {
      const selected = this.$refs['datatable-app-documents'].dataValue
      if (selected.length) {
        const datatableId = selected[0].id
        const response = await commonsApi.axiosPostWrapper('/datatables/es-search', {
          ids: [datatableId],
          fields: ['id', 'slug']
        })
        if (response.data.count) {
          this.formData.customDatatableForBUDD = response.data.items[0]?.slug
        }
      }
    },
    async onConfirmCustomBlueprintsDatatableToUse () {
      const selected = this.$refs['datatable-app-blueprints'].dataValue
      if (selected.length) {
        const datatableId = selected[0].id
        const response = await commonsApi.axiosPostWrapper('/datatables/es-search', {
          ids: [datatableId],
          fields: ['id', 'slug']
        })
        if (response.data.count) {
          this.formData.customDatatableForBlueprints = response.data.items[0]?.slug
        }
      }
    },
    async onUnpublish () {
      try {
        this.isLoading = true

        await commonsApi.axiosPutWrapper(`/processtypes/unpublish/${this.$route?.params?.id}`)
        this.lmToastSuccessMessage(`Se despublicó el tipo de proceso correctamente.`, 'Se despublicó correctamente')

        setTimeout(() => {
          this.$router.push(this.pathToRedirectOnCancel)
        }, 650)
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    async reloadDocumentationSamples () {
      const apiIntegrationCodeSampleReq = await commonsApi.axiosGetWrapper(`/processtypes/documentation-sample/${this.$route?.params?.id}`)
      this.apiIntegrationCodeSample = apiIntegrationCodeSampleReq.data
    },
    async renderEmailTemplatePreview (id, emailContext, renderizedEmailTemplate) {
      try {
        const mjmlRenderizedResponse = await commonsApi.axiosPostWrapper('/mailertemplate/render', {
          id: id,
          emailContext: emailContext
        })
        this[renderizedEmailTemplate] = mjmlRenderizedResponse?.data || ''
      } catch (error) {
        this[renderizedEmailTemplate] = 'Lo sentimos no hemos podido renderizar el template'
      }
    }
  },
  async created () {
    try {
      const res = await commonsApi.axiosGetWrapper('/processtypes/cancreatenew')
      if (!res.data) {
        // Debe crear un tipo de persona/iniciador
        this.$bvModal.show('create-starter-modal')
      }

      const mailertemplateResponse = await commonsApi.axiosGetWrapper(this.mailerTemplatePath)
      this.mailertemplateOptions = mailertemplateResponse.data.items.map(el => ({ id: el._id, name: el.name }))

      if (this.isOnEditMode) {
        const { data } = await commonsApi.axiosGetWrapper(`processtypes/${this.$route.params.id}`)
        // Cargo las propiedades en modo edición
        for (const key in this.formData) {
          if (data.hasOwnProperty(key)) {
            this.formData[key] = data[key]
          }
        }
        this.form.formElements = data?.processFields || []
        this.form.validations = data?.processFieldsValidations || {}

        if (this.formData.isEditable === false) {
          this.modes.selected = 'preview'
          this.modes.editView = false
        }
      }
    } catch (error) {
      console.log(error)
    }
  },
  async mounted () {
    // Opciones para duplicar tipos de trámite
    const processTypes = await commonsApi.axiosGetWrapper('/processtypes/?pageSize=100')
    const options = processTypes.data.rows.filter(process => process._id !== this.$route?.params?.id).map(process => {
      return {
        id: process._id,
        name: process.typeName
      }
    })
    this.processTypesOptionsForDuplicate = options

    const apiIntegrationCodeSampleReq = await commonsApi.axiosGetWrapper(`/processtypes/documentation-sample/${this.$route?.params?.id}`)
    this.apiIntegrationCodeSample = apiIntegrationCodeSampleReq.data

    const prefixOptions = await commonsApi.axiosGetWrapper(`/customer/processprefixes/${this.formData.typeNumerator}`)
    this.prefixOptions = prefixOptions.data.items.map(el => {
      return {
        id: el.id,
        name: el.prefix,
        numeratorType: el.numeratorType
      }
    })
  }
}

</script>

<style scoped>
.circle {
  background: white;
  color: black;
  border-radius: 50%;
  width: 25px;
  height: 25px;
  text-align: center;
}

.collapse-formsection-up.collapsed {
  display: inherit;
}

.collapse-formsection-up.not-collapsed {
  display: none;
}

.collapse-formsection-down.not-collapsed {
  display: inherit;
}

.collapse-formsection-down.collapsed {
  display: none;
}

.formbuilder-component-section, .formbuilder-preview-section {
  overflow: auto;
  max-height: 800px;
}
</style>
